export const TYPE_DATAS = [
  {
    typeName: "A",
    title: "安定した頭皮環境",
    description: `豊かな毛髪を育む土台が整っています。現状を維持しつつ、理想の髪質に向けた積極的なケアを行いましょう。`,
    badge: "OPTIMAL",
    tags: ["安定ケア", "#美髪ケア", "#継続ケア"],
  },
  {
    typeName: "B",
    title: "安定しているがケアの余地あり",
    description: `全体的に安定していますが、酸化ストレスなどの特定指標に改善の余地があります。弱点を補うケアでAタイプへの到達が可能です。`,
    badge: "STABLE",
    tags: ["安定ケア", "#酸化ケア", "#保湿強化"],
  },
  {
    typeName: "C",
    title: "ケアの見直しがおすすめ",
    description: `複数の指標に乱れが見られます。放置すると頭皮環境が悪化する可能性があるため、早めのケアの見直しをおすすめします。`,
    badge: "CAUTION",
    tags: ["集中ケア", "#保湿ケア", "#バリア機能ケア"],
  },
  {
    typeName: "D",
    title: "集中的なケアを検討したい",
    description: `トラブルを未然に防ぐため、即効性の高いサロンケアとホームケアの両立を強く推奨します。`,
    badge: "WARNING",
    tags: ["緊急ケア", "#早期対策", "#トラブル予防"],
  },
  {
    typeName: "E",
    title: "早めのケア見直しをおすすめします",
    description: `全体的に数値が著しく低下しており、深刻な状態です。早急に専門的な頭皮集中ケアを開始し、環境の立て直しを図る必要があります。`,
    badge: "CRITICAL",
    tags: ["緊急ケア", "#集中ケア", "#トラブルケア"],
  },
  // AB → A
  {
    typeName: "AB",
    title: "安定した頭皮環境",
    description: `豊かな毛髪を育む土台が整っています。現状を維持しつつ、理想の髪質に向けた積極的なケアを行いましょう。`,
    badge: "OPTIMAL",
    tags: ["安定ケア", "#美髪ケア", "#継続ケア"],
  },
  // BA → B
  {
    typeName: "BA",
    title: "安定しているがケアの余地あり",
    description: `全体的に安定していますが、酸化ストレスなどの特定指標に改善の余地があります。弱点を補うケアでAタイプへの到達が可能です。`,
    badge: "STABLE",
    tags: ["安定ケア", "#酸化ケア", "#保湿強化"],
  },
  // AC → C
  {
    typeName: "AC",
    title: "ケアの見直しがおすすめ",
    description: `複数の指標に乱れが見られます。放置すると頭皮環境が悪化する可能性があるため、早めのケアの見直しをおすすめします。`,
    badge: "CAUTION",
    tags: ["集中ケア", "#保湿ケア", "#バリア機能ケア"],
  },
  // CA → D
  {
    typeName: "CA",
    title: "集中的なケアを検討したい",
    description: `トラブルを未然に防ぐため、即効性の高いサロンケアとホームケアの両立を強く推奨します。`,
    badge: "WARNING",
    tags: ["緊急ケア", "#早期対策", "#トラブル予防"],
  },
  // BD → E
  {
    typeName: "BD",
    title: "早めのケア見直しをおすすめします",
    description: `全体的に数値が著しく低下しており、深刻な状態です。早急に専門的な頭皮集中ケアを開始し、環境の立て直しを図る必要があります。`,
    badge: "CRITICAL",
    tags: ["緊急ケア", "#集中ケア", "#トラブルケア"],
  },
  // DB → A
  {
    typeName: "DB",
    title: "安定した頭皮環境",
    description: `豊かな毛髪を育む土台が整っています。現状を維持しつつ、理想の髪質に向けた積極的なケアを行いましょう。`,
    badge: "OPTIMAL",
    tags: ["安定ケア", "#美髪ケア", "#継続ケア"],
  },
  // CD → B
  {
    typeName: "CD",
    title: "安定しているがケアの余地あり",
    description: `全体的に安定していますが、酸化ストレスなどの特定指標に改善の余地があります。弱点を補うケアでAタイプへの到達が可能です。`,
    badge: "STABLE",
    tags: ["安定ケア", "#酸化ケア", "#保湿強化"],
  },
  // DC → C
  {
    typeName: "DC",
    title: "ケアの見直しがおすすめ",
    description: `複数の指標に乱れが見られます。放置すると頭皮環境が悪化する可能性があるため、早めのケアの見直しをおすすめします。`,
    badge: "CAUTION",
    tags: ["集中ケア", "#保湿ケア", "#バリア機能ケア"],
  },
  // DE → D
  {
    typeName: "DE",
    title: "集中的なケアを検討したい",
    description: `トラブルを未然に防ぐため、即効性の高いサロンケアとホームケアの両立を強く推奨します。`,
    badge: "WARNING",
    tags: ["緊急ケア", "#早期対策", "#トラブル予防"],
  },
  // ED → E
  {
    typeName: "ED",
    title: "早めのケア見直しをおすすめします",
    description: `全体的に数値が著しく低下しており、深刻な状態です。早急に専門的な頭皮集中ケアを開始し、環境の立て直しを図る必要があります。`,
    badge: "CRITICAL",
    tags: ["緊急ケア", "#集中ケア", "#トラブルケア"],
  },
];
